/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import React from 'react';
import { ConfigProvider, Input } from 'antd';
import ReactDOMServer from "react-dom/server";
import GoogleMapReact from 'google-map-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";

import MapPopup from '../MapPopup/MapPopup';

import MapMarkerPin from '../../../assets/MapMarkerPin.svg';
import MyLocation from '../../../assets/MyLocation.svg';
import MapSuggestionIcon from '../../../assets/MapSuggestionIcon.svg';
import Add from '../../../assets/Add.svg';
import Minus from '../../../assets/Minus.svg';

import './Map.scss';

let marker: any;
let markerIcon: any = MapMarkerPin;
let infowindow: any;
const win: any = window;

interface Props {
    callbackAddress?: any;
    callbackCityName?: any;
    placeholder?: string;
    rtl: boolean;
    center?: { lat: number; lng: number };
    zoom?: number;
    dispatch?: any;
    mapValue?: string;
    labelleft?: string;
    isOutOfCoverage?: boolean;
    onInfoWindowClose?: () => void;
    loadCurrLoc?: boolean;
}


const key = win['storeGoogleMapKey'];

class Map extends React.Component<Props, any> {

    static defaultProps = {
        center: { lat: 24.7135517, lng: 46.6752957 },
        zoom: 11,
    };

    state = {
        mapApiLoaded: false,
        mapInstance: null,
        mapApi: null,
        geoCoder: null,
        places: [],
        center: this.props.center,
        placeId: this.props.placeId,
        zoom: this.props.zoom,
        address: "",
        draggable: true,
        lat: 24.7135517,
        lng: 46.6752957,
        isScriptLoaded: false
    }

    handleClickElement = ({ x, y, lat, lng, event }: any) => {
        this.setState({
            lat: lat,
            lng: lng,
            center: { lat: lat, lng: lng }
        });
        markerIcon = MapMarkerPin;
        if (infowindow) {
            infowindow.close();
        }
        if (this.props.onInfoWindowClose) {
            this.props.onInfoWindowClose();
        }
        this.setCurrentLocation(true);
    };

    apiHasLoaded = (map: any, maps: any) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
            isScriptLoaded: true
        }, () => this.setCurrentLocation(false));
        // this.addMyLocationButton(map, maps);
        this.customZoomInControl(map, maps);
    };

    customZoomInControl(map: google.maps.Map, maps: typeof google.maps) {
        let controlDiv = document.createElement("div");
        controlDiv.className = 'map__customZoom';

        const buttonAdd = document.createElement("button");
        buttonAdd.className = "zoom__control";

        const iconAddDiv = document.createElement("div");
        iconAddDiv.className = "zoom__plus"
        iconAddDiv.style.backgroundImage = `url("${Add}")`;
        buttonAdd.appendChild(iconAddDiv);

        const buttonSub = document.createElement("button");
        buttonSub.className = "zoom__control";

        const iconSubDiv = document.createElement("div");
        iconSubDiv.className = "zoom__minus";
        iconSubDiv.style.backgroundImage = `url("${Minus}")`;
        buttonSub.appendChild(iconSubDiv);

        controlDiv.appendChild(buttonAdd);
        controlDiv.appendChild(buttonSub);

        map.controls[maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);

        buttonAdd.addEventListener("click", () => {
            const currentZoom = map?.getZoom();
            if (map && currentZoom !== undefined) {
                map.setZoom(currentZoom + 1);
            }
        });

        buttonSub.addEventListener("click", () => {
            const currentZoom = map?.getZoom();
            if (map && currentZoom !== undefined) {
                map.setZoom(currentZoom - 1);
            }
        });
    }

    handleCurrentLocationClick = (e: any) => {
        e.preventDefault();
        markerIcon = MapMarkerPin;
        if (infowindow) {
            infowindow.close();
        }
        if (this.props.onInfoWindowClose) {
            this.props.onInfoWindowClose();
        }
        this.setCurrentLocation(false);
    }

    setCurrentLocation(isCordProvided: any) {
        const { mapApi } = this.state;
        const { dispatch } = this.props;

        navigator.geolocation.getCurrentPosition(position => {
            if (position.coords.latitude !== null && position.coords.longitude !== null && mapApi !== null) {
                if (!isCordProvided) {
                    this.setState({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                }

                setTimeout(() => {
                    const geocoder = new mapApi.Geocoder();
                    geocoder.geocode({
                        location: {
                            lat: parseFloat(this.state.lat),
                            lng: parseFloat(this.state.lng),
                        }
                    }, (results: any, status: any) => {
                        dispatch({ type: 'LOADER', payload: { loading: false } });

                        const myLatlng = {
                            lat: this.state.lat,
                            lng: this.state.lng,
                        };

                        this.setState({
                            center: myLatlng
                        })

                        this.userLocationMarker(myLatlng);

                        if (status === "OK") {
                            this.userAddress(results);
                            this.handleAddressChange(results[0].formatted_address, myLatlng, this.state.placeId);
                        } else {
                            console.log("Geocoder failed due to: " + status);
                        }
                    })
                }, 100)
            }
        }, (error) => {
            const { center, mapApi } = this.state;
            const geocoder = new mapApi.Geocoder();

            this.userLocationMarker(center);
            setTimeout(() => {
                geocoder.geocode({ location: center }, (res, status) => {
                    if (status === 'OK') {
                        this.setState({
                            address: res[0].formatted_address
                        })
                        this.userAddress(res);
                    }
                })
            }, 100)
            dispatch({ type: 'LOADER', payload: { loading: false } });
        });
    }

    handleAddressChange = (value: any, ltLg: any, placeId: any) => {
        this.setState({
            address: value,
            placeId: placeId
        })
        this.props.callbackAddress(value, ltLg, placeId);
    }

    handleSelect = async (value: any) => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        this.setState({
            center: {
                lat: latLng.lat,
                lng: latLng.lng,
            },
            lat: latLng.lat,
            lng: latLng.lng,
            address: value,
            placeId: results[0].place_id,
        });
        markerIcon = MapMarkerPin;
        this.state.mapInstance.setZoom(18);
        this.setCurrentLocation(true);
        // this.handleAddressChange(value, latLng);
    }

    userLocationMarker = (myLatlng = center) => {
        const { mapApi } = this.state;

        if (this.state.mapInstance) {
            this.state.mapInstance.setCenter(myLatlng);
            this.state.mapInstance.setZoom(16);

            if (marker) {
                marker.setMap(null);
            }

            marker = new mapApi.Marker({
                position: myLatlng,
                icon: markerIcon
            });

            if (!infowindow) {
                infowindow = new mapApi.InfoWindow({
                    content: '',
                    width: 200,
                });

                infowindow.addListener('closeclick', () => {
                    // this.props.onInfoWindowClose();
                });
            }

            marker.addListener("mouseover", () => {
                if (!this.props.isOutOfCoverage) {
                    const mapPopup = ReactDOMServer.renderToString(
                        <MapPopup address={this.state.address} outOfDelivery={false} />
                    );

                    infowindow.setContent(mapPopup);

                    infowindow.open({
                        anchor: marker,
                        map: mapApi,
                        shouldFocus: false,
                    });
                }
            });

            marker.setMap(this.state.mapInstance);
        }
    }

    userAddress = (results) => {
        const { center, placeId } = this.state;

        if (results[0]) {
            const cityName = results[0]?.address_components.filter((val: any) => {
                return val?.types.includes('locality')
            })[0]?.short_name;

            const region = results[0]?.address_components.filter((val: any) => {
                return val?.types.includes("sublocality") || val?.types.includes("administrative_area_level_2")
            })[0]?.long_name;

            let value = '';
            results[0]?.address_components.map((val: any) => {
                if (val?.types.includes("premise")) {
                    value += `${val.long_name},`
                }
                if (val?.types.includes("plus_code")) {
                    value += `${val.long_name},`
                }
                if (val?.types.includes("street_number")) {
                    value += `${val.long_name},`
                }
                if (val?.types.includes("establishment")) {
                    value += `${val.long_name},`
                }
                if (val?.types.includes("street_number")) {
                    value += `${val.long_name},`
                }
                if (val?.types.includes("route")) {
                    value += `${val.long_name},`
                }
            });

            let addressLine = ''
            if (value.lastIndexOf(',') === value.length - 1) {
                addressLine = value.substring(0, value.lastIndexOf(','))
            }

            this.props.callbackCityName(cityName, region, addressLine);
            this.handleAddressChange(results[0].formatted_address, center);
        }
    }

    getPlaceAutoComplete = () => {
        const { rtl, placeholder, labelleft, mapValue } = this.props;

        if (this.state.isScriptLoaded) {
            return (
                <PlacesAutocomplete
                    value={this.state.address}
                    onSelect={this.handleSelect}
                    onChange={this.handleAddressChange}
                    searchOptions={{ componentRestrictions: { country: ["sa"] } }}
                >
                    {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                    }) => (
                        <>
                            <ConfigProvider direction={rtl ? "rtl" : "ltr"}>
                                <div className={rtl ? 'DD__MapInput DD__MapInput_right' : 'DD__MapInput DD__MapInput_left'}>
                                    <div className='MapInput__Icon'>
                                        <Input
                                            rtl={rtl}
                                            id="mapReciverAddress"
                                            className="input-section"
                                            value={mapValue}
                                            {...getInputProps({
                                                placeholder: placeholder,
                                            })}
                                        />
                                        <img id="mapCurrentLocation" src={MyLocation} className={rtl ? 'locate-icon-rtl' : 'locate-icon-ltr'} alt='icon' onClick={(e) => this.handleCurrentLocationClick(e)} />
                                    </div>
                                    <div className={`helperText-section ${rtl ? 'floatRtl' : ''}`}>
                                        <div className='helperText-left'>{labelleft}</div>
                                        <div className='helperText-right'>{}</div>
                                    </div>

                                    <div className='map__suggestion'>
                                        {loading && <div className='MS__loading'>Loading...</div>}
                                        {suggestions.map((suggestion, index) => {
                                            const style = {
                                                backgroundColor: suggestion.active ? "#C3CED0" : "#fff",
                                                cursor: 'pointer',
                                                display: loading ? 'none' : 'block',
                                                padding: '4px',
                                                borderBottom: '2px solid #eee'
                                            };
                                            return (
                                                <div key={suggestion.description + index} style={style}>
                                                    <div style={{ display: 'inline-flex' }} {...getSuggestionItemProps(suggestion)}>
                                                        <img style={{ paddingRight: 10, paddingLeft: 10 }} src={MapSuggestionIcon} alt='map-suggestion' />
                                                        <div>{suggestion.description}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </ConfigProvider>
                        </>
                    )}
                </PlacesAutocomplete>
            )
        } else {
            return <></>;
        }
    }

    render() {
        const defaultMapOptions = {
            zoomControl: false,
            fullscreenControl: false
        };

        if (this.props.isOutOfCoverage) {
            if (infowindow) {
                infowindow.close();
            }

            const mapPopup = ReactDOMServer.renderToString(
                <MapPopup outOfDelivery={true} />
            );

            if (marker) {
                infowindow.setContent(mapPopup);
                infowindow.open({
                    anchor: marker,
                    map: this.state.mapApi,
                    shouldFocus: false,
                });
            }
        }

        return (
            <>

                {this.getPlaceAutoComplete()}
                <div className='DD__Mapcontainer'>
                    <GoogleMapReact
                        center={this.state.center}
                        zoom={10}
                        draggable={this.state.draggable}
                        options={{
                            fullscreenControl: false,
                            disableDefaultUI: true
                        }}
                        onClick={this.handleClickElement}
                        bootstrapURLKeys={{
                            key: key,
                            libraries: ["places", "geometry"],
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) =>
                            this.apiHasLoaded(map, maps)
                        }
                    >
                    </GoogleMapReact>
                </div>
            </>
        )
    }
}

export default Map;